import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type ScrollLayoutProps = {
    /** Obalovaná komponenta */
    children: ReactNode;
    /** Fixní kladná výška rozložení v pixelech */
    height?: number;
    /** Příznak, zda je aktivní horizontální scrollování */
    horizontal?: boolean;
    /** Příznak, zda je aktivní vertikální scrollování */
    vertical?: boolean;
    /** Fixní kladná šířka rozložení v pixelech */
    width?: number;
};

const classNames = bemClassNames("scroll-layout-component");

/** Rozložení umožňující scrollování obsahu a nastavení fixní velikosti */
export const ScrollLayout: FunctionComponent<ScrollLayoutProps> = ({
    children,
    height,
    horizontal = true,
    vertical = true,
    width,
}) => (
    <div
        style={{ height, width }}
        className={classNames({ vertical, horizontal })}
    >
        {children}
    </div>
);
